import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchBasAgent } from '../actions/basAgentActions';

export default function useSelectedAgent(basAgentId) {
    const dispatch = useDispatch();
    const selectedAgent = useSelector(({ basAgent }) => {
        const { basAgents, selectedAgentId } = basAgent;
        return basAgents[selectedAgentId];
    });
    const [loading, setLoading] = useState(false);
    const [fetchedId, setFetchedId] = useState('');

    // Fetch the selected agent if needed
    useEffect(() => {
        if (!basAgentId) {
            return;
        }
        if (loading || fetchedId === basAgentId) {
            return;
        }
        const runFetchAgent = async () => {
            setFetchedId(basAgentId);
            setLoading(true);
            try {
                await dispatch(fetchBasAgent(basAgentId));
                setLoading(false);
            } catch (error) {
                setFetchedId('');
                setLoading(false);
                throw error;
            }
        };
        runFetchAgent();
    }, [basAgentId, loading, selectedAgent]);

    const basType =
        get(selectedAgent, 'driverConfiguration[0].basType');

    return { basType, loading, selectedAgent };
}
